import React from "react";
import { useSearchParams } from "react-router-dom";
import PerformanceReport from "./modules/dashboardV2/PerformanceReport";
import ProcessingDataTable from "./modules/dashboardV2/ProcessingDataTable";
import PerformanceDashboard from "./modules/dashboardV2/PerformanceDashboard";
import IframeView from "./modules/dashboardV2/IframeView";

export default function HomeWrapper() {
    const [searchParams] = useSearchParams();
    const mode = searchParams.get("show");

    switch (mode) {
        case "overview":
            return <PerformanceDashboard/>;
        case "processingDataTable":
            return <ProcessingDataTable/>;
        case "report":
            return <PerformanceReport/>;
        case "bullDashboard":
            return <IframeView/>;
        default:
            return <PerformanceDashboard/>;
    }
}
